function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

function ensureLeadingSlash(value: string) {
  if (!value) return '/'
  return value.startsWith('/') ? value : `/${value}`
}

function joinUrl(baseURL: string, path: string) {
  const normalizedBaseURL = trimTrailingSlash(baseURL)
  const normalizedPath = ensureLeadingSlash(path)
  return `${normalizedBaseURL}${normalizedPath}`
}

function toPositiveNumber(value: string | undefined, fallback: number) {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

const apiBaseURL = trimTrailingSlash(process.env.CAT_API_BASE_URL || '/v1')
const socketOrigin = trimTrailingSlash(process.env.CAT_SOCKET_ORIGIN || '')
const socketNamespace = ensureLeadingSlash(process.env.CAT_SOCKET_NAMESPACE || '/chat')
const uploadEnvironment = process.env.CAT_UPLOAD_ENVIRONMENT || 'test'

export const appConfig = {
  appName: process.env.CAT_APP_NAME || 'cat-pet-platform',
  api: {
    baseURL: apiBaseURL,
    refreshURL: joinUrl(apiBaseURL, '/auth/refresh'),
    githubLoginURL: joinUrl(apiBaseURL, '/auth/github')
  },
  sse: {
    notificationsURL: joinUrl(apiBaseURL, process.env.CAT_SSE_PATH || '/notifications/stream'),
    reconnectDelayMs: toPositiveNumber(process.env.CAT_SSE_RECONNECT_DELAY, 3000)
  },
  socket: {
    url: `${socketOrigin}${socketNamespace}`,
    namespace: socketNamespace,
    path: ensureLeadingSlash(process.env.CAT_SOCKET_PATH || '/socket.io')
  },
  upload: {
    projectKey: process.env.CAT_UPLOAD_PROJECT_KEY || 'kitty2026',
    environment:
      uploadEnvironment === 'dev' || uploadEnvironment === 'test' || uploadEnvironment === 'prod'
        ? uploadEnvironment
        : 'test'
  }
} as const

export function buildApiUrl(path: string) {
  return joinUrl(appConfig.api.baseURL, path)
}
